import { useState, useEffect } from "react";
import Lottie from "react-lottie";
import animationData from "../../../src/jsons/LoadingBg.json";
import InfiniteScroll from "react-infinite-scroll-component";
import { axiosPrivate } from "../../api/axios";
import { useInfiniteQuery } from "@tanstack/react-query";
import ShopsDetailsCard from "../../components/shops/ShopsDetailsCard";
import ContactInfo from "../../components/features/Store/ContactInfo";
import FilterShops from "../../components/common/FilterShops";

const UserFormStep5 = ({
  isInUserForm,
  formNo,
  setFormNo,
  setEnteredUser,
  enteredUser,
}: any) => {
  const [showModal, setShowModal] = useState(false);
  const [moreData, setMoreData] = useState(false);
  const [storeName, setStoreName] = useState("");
  const [telNumber, setTelNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [logoShop, setLogoShops] = useState("");
  const [provinceId, setProvinceId] = useState<any>("");
  const [city_Id, setCity_Id] = useState<any>("");
  const [inputQuery, setInputQuery] = useState(
    localStorage?.getItem("user-store-selected") || ""
  );
  const [searchQuery, setSearchQuery] = useState<any>("");
  const [store_group, setStore_group] = useState<any>(undefined);
  const [productgroup_uuid, setProductgroup_uuid] = useState<any>([]);

  const handleShowModalChange = (newShowModalState: any) => {
    setShowModal(newShowModalState);
  };

  const setVar = (
    storeName: any,
    telNumber: any,
    phoneNumber: any,
    logoShop: any
  ) => {
    setStoreName(storeName);
    setTelNumber(telNumber);
    setPhoneNumber(phoneNumber);
    setLogoShops(logoShop);
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "svg",
  };

  const getShopsList = async ({ pageParam = 1 }) => {
    setMoreData(true);
    const response = await axiosPrivate.get(
      `/store/stores/?page=${pageParam}&page_size=10&search_query=${encodeURIComponent(
        localStorage?.getItem("user-store-selected") === inputQuery
          ? localStorage?.getItem("user-store-selected")
          : searchQuery
      )}&province_id=${provinceId}${
        store_group ? `&store_group=${store_group.value}` : ``
      }&city_id=${city_Id}&productgroup_uuid=${productgroup_uuid}`
    );
    setMoreData(false);

    return {
      ...response.data,
      previous: pageParam,
    };
  };

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isLoading,
  } = useInfiniteQuery({
    queryKey: [`fetchImage`],
    queryFn: (pageParam) => getShopsList(pageParam),
    initialPageParam: 1,

    getNextPageParam: (lastPage) => {
      if (!lastPage.data.next) return undefined;
      return lastPage.previous + 1;
    },
  });

  useEffect(() => {
    refetch();
  }, [
    searchQuery,
    refetch,
    city_Id,
    provinceId,
    store_group,
    productgroup_uuid,
    inputQuery,
    localStorage?.getItem("user-store-selected"),
  ]);

  const handleKeyDown = (event: any) => {
    setSearchQuery(inputQuery);
  };

  const results = data?.pages?.reduce(
    (acc, page) => [...acc, ...page.data.results],
    []
  );

  return (
    <div className="flex flex-col w-full max-w-[1900px]">
      <InfiniteScroll
        style={{ overflow: "hidden" }}
        className="p-2"
        dataLength={results ? results.length : 0}
        next={fetchNextPage}
        hasMore={hasNextPage && !isFetchingNextPage}
        loader={
          isFetchingNextPage ? "در حال بارگذاری" : "فروشگاه دیگری وجود ندارد"
        }
      >
        <div className="border rounded-xl shadow-button_sm_hover p-6 w-full">
          <div className="flex justify-between px-4">
            <div className="flex pt-3 pb-3 pr-4 pl-4 justify-end items-center rounded-lg bg-gray-50 border border-solid border-gray-300 sm:w-auto max-sm:w-[100px]">
              <img src="/icons/search.svg" alt="search.svg not found" />
              <input
                placeholder=" جستجو فروشگاه"
                value={inputQuery}
                onChange={(e) => setInputQuery(e.target.value)}
                onKeyDown={handleKeyDown}
                className="flex focus:outline-none w-full flex-col justify-center self-stretch flex-1 bg-gray-50 text-right text-gray-500"
                type="search"
              />
            </div>

            <FilterShops
              provinceId={provinceId}
              setProvinceId={setProvinceId}
              city_Id={city_Id}
              setCity_Id={setCity_Id}
              inputQuery={inputQuery}
              store_group={store_group}
              setStore_group={setStore_group}
              setInputQuery={setInputQuery}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              productgroup_uuid={productgroup_uuid}
              setProductgroup_uuid={setProductgroup_uuid}
            />
          </div>
          {isLoading ? (
            <>
              <Lottie options={defaultOptions} height={100} width={100} />
            </>
          ) : (
            <div className="min-h-[600px] w-full mx-auto ">
              <div className="flex flex-wrap w-full mx-auto">
                {results?.length !== 0 ? (
                  results?.map((result: any, index: any) => (
                    <div
                      key={index}
                      className="p-4 element min-w-[600px] max-w-[600px] mx-auto"
                    >
                      <ShopsDetailsCard
                        setEnteredUser={setEnteredUser}
                        enteredUser={enteredUser}
                        hasButtonShop={true}
                        result={result}
                        openFunc={handleShowModalChange}
                        onSetStore={setVar}
                        formNo={formNo}
                        setFormNo={setFormNo}
                        isInUserForm={isInUserForm}
                      />
                    </div>
                  ))
                ) : (
                  <>
                    <div className="p-4 element md:min-w-[700px] w-full flex items-center justify-center mx-auto">
                      فروشگاهی با این مشخصات وجود ندارد.
                    </div>
                  </>
                )}
              </div>
              {moreData && (
                <>
                  <Lottie options={defaultOptions} height={100} width={100} />
                </>
              )}
            </div>
          )}
        </div>
        {showModal && (
          <ContactInfo
            onShowModalChange={handleShowModalChange}
            telNumber={telNumber}
            storeName={storeName}
            phoneNumber={phoneNumber}
            logoShop={logoShop}
          />
        )}
      </InfiniteScroll>
    </div>
  );
};
export default UserFormStep5;
